
import { defineComponent } from 'vue'
import { addOrRemove, contains, isSelectable, isMovable } from './selectedOperandService'
import { swap, move } from './advancedFilterService'
import { getFilterTree } from './treeService'

const crypto = require('crypto')
const deepEqual = require('deep-equal')

export default defineComponent({
    name: 'qbe-group',
    components: {},
    props: { propNode: { type: Object } },
    emits: ['selectedChanged', 'treeUpdated'],
    data() {
        return {
            node: {} as any,
            selected: false,
            dropzoneTopVisible: false,
            dropzoneBottomVisible: false,
            groupId: crypto.randomBytes(16).toString('hex')
        }
    },
    watch: {
        propNode: {
            handler() {
                this.loadNode()
            },
            deep: true
        }
    },
    async created() {
        this.loadNode()
    },
    methods: {
        loadNode() {
            this.node = this.propNode as any
        },
        onDragStart(event: any) {
            event.dataTransfer.setData('text/plain', JSON.stringify(this.node))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
        },
        select(node) {
            addOrRemove(node)
            this.selected = this.isSelected()
            this.$emit('selectedChanged')
        },
        isSelected() {
            return contains(this.node)
        },
        isSelectable() {
            return isSelectable(this.node)
        },
        onDropComplete(event) {
            this.hideDropzone('top')
            const eventData = JSON.parse(event.dataTransfer.getData('text/plain'))
            if (!deepEqual(eventData, this.node)) {
                swap(getFilterTree(), eventData, this.node)
                this.$emit('treeUpdated')
            }
        },
        onDropMove(event) {
            this.hideDropzone('bottom')
            const eventData = JSON.parse(event.dataTransfer.getData('text/plain'))
            if (isMovable(eventData)) {
                if (!deepEqual(eventData, this.node)) {
                    move(getFilterTree(), eventData, this.node)
                    this.$emit('treeUpdated')
                }
            }
        },
        displayDropzone(position: string) {
            if (position === 'top') {
                this.dropzoneTopVisible = true
            } else {
                this.dropzoneBottomVisible = true
            }
            const id = `group-${position}-${this.groupId}` as string
            ;(this.$refs as any)[id].classList.add('filter-dropzone-active')
        },
        hideDropzone(position: string) {
            if (position === 'top') {
                this.dropzoneTopVisible = false
            } else {
                this.dropzoneBottomVisible = false
            }
            const id = `group-${position}-${this.groupId}` as string
            ;(this.$refs as any)[id].classList.remove('filter-dropzone-active')
        }
    }
})
